<template>
    <div>
        <page-header :title="$t('privateProfile.title')" />
        <ad-leaderboard />
        <ion-item lines="none" class="profile-settings-header">
            <h4 class="ion-no-padding" slot="start" style="font-weight:600">
                {{ $t('privateProfile.yourProfile') }}
            </h4>
            <ion-button slot="end" @click="toggleSettings" class="settings-button" strong>
                <img src="@/assets/icon-images/settings.png" class="icon-img-xs" />
                {{ $t('master.settings') }}
            </ion-button>
        </ion-item>
        <ion-item v-if="showingSettings" class="profile-settings-header" lines="none">
            <ul slot="end" class="settings-list">
                <li>
                    <router-link :to="user.has_access ? '/edit-profile' : '/plans'">
                        <ion-item lines="none" color="secondary" class="settings-list-item">
                            <img class="icon-img-xs" src="@/assets/icon-images/edit.png" />
                            &nbsp; {{ $t('privateProfile.editProfile') }}
                        </ion-item>
                    </router-link>
                </li>
                <li>
                    <router-link to="/change-password">
                        <ion-item lines="none" color="secondary" class="settings-list-item">
                            <img class="icon-img-xs" src="@/assets/icon-images/key.png" />
                            &nbsp; {{ $t('master.changePassword') }}
                        </ion-item>
                    </router-link>
                </li>
                <li>
                    <router-link to="/edit-profile-pictures">
                        <ion-item lines="none" color="secondary" class="settings-list-item">
                            <img class="icon-img-xs" src="@/assets/icon-images/cam.png" />
                            &nbsp; {{ $t('privateProfile.uploadImages') }}
                        </ion-item>
                    </router-link>
                </li>
                <li>
                    <router-link to="/blocked-users">
                        <ion-item lines="none" color="secondary" class="settings-list-item">
                            <img class="icon-img-xs" src="@/assets/icon-images/warning.png" />
                            &nbsp; {{ $t('privateProfile.blockedUsers') }}
                        </ion-item>
                    </router-link>
                </li>
            </ul>
        </ion-item>
        <ion-grid class="stats-wrapper">
            <ion-row>
                <ion-col @click="redirectToVisitors()" size="6" size-xl="4" class="ion-no-padding clickable">
                    <ion-item class="first-row" lines="none">
                        <ion-text slot="start" class="ion-no-margin"
                            ><b>{{ $t('privateProfile.profileVisitors') }}</b>
                        </ion-text>
                        <ion-text slot="end" class="ion-no-margin" color="primary">
                            <b>{{ receivedViewsCount }}</b>
                        </ion-text>
                    </ion-item>
                </ion-col>
                <ion-col @click="redirectToChat()" size="6" size-xl="4" class="ion-no-padding clickable">
                    <ion-item class="first-row sent-messages-box" lines="none">
                        <ion-text slot="start" class="ion-no-margin"
                            ><b>{{ $t('privateProfile.sentMessages') }}</b>
                        </ion-text>
                        <ion-text slot="end" class="ion-no-margin" color="primary">
                            <b>{{ sentMessagesCount }}</b>
                        </ion-text>
                    </ion-item>
                </ion-col>
                <ion-col @click="redirectToChat()" size="12" size-xl="4" class="ion-no-padding clickable">
                    <ion-item class="second-row" lines="none">
                        <ion-text slot="start" class="ion-no-margin">
                            <b> {{ $t('privateProfile.receivedMessages') }}</b>
                        </ion-text>
                        <ion-text slot="end" color="primary">
                            <b> {{ receivedMessagesCount }} </b>
                        </ion-text>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>
        <ion-grid v-if="user && !user.has_access">
            <ion-row class="upgrade-membership">
                <ion-col size="12" size-xl="6" class="ion-no-padding">
                    <ion-text class="ion-float-start ion-padding-start membership-title" color="secondary">
                        {{ $t('privateProfile.membershipTitle') }}
                    </ion-text>
                    <ion-text class="ion-float-start ion-padding membership-text">{{
                        $t('privateProfile.membershipText')
                    }}</ion-text></ion-col
                >
                <ion-col size="12" size-xl="6" class="ion-no-padding">
                    <ion-button class="upgrade-button" strong @click="upgradeMembership">{{
                        $t('master.membershipUpgrade')
                    }}</ion-button></ion-col
                >
            </ion-row>
        </ion-grid>
        <ion-row>
            <ion-col size="12" size-xl="6" class="ion-no-margin ion-no-padding">
                <ion-item class="ion-margin-top ion-padding-left header-box" lines="none">
                    <div slot="start">
                        <ion-text class="likes-title" color="secondary">{{ $t('privateProfile.likesReceivedTitle') }}</ion-text>
                    </div>
                    <div class="numbers" slot="end">
                        <ion-text color="primary">{{ receivedLikesCount }}</ion-text>
                    </div>
                </ion-item>
                <ion-item class="interactions-wrapper" lines="none">
                    <ion-text class="ion-float-start interactions">
                        {{ receivedLikesCount }}
                        {{ $t('privateProfile.likesReceivedText') }}
                    </ion-text>
                </ion-item>
                <ion-grid class="user-cards">
                    <ion-row>
                        <ion-col v-for="like in receivedLikes" :key="like.from_user.id" size-xs="6" size-sm="6" size-md="4">
                            <user-card :user="like.from_user" />
                        </ion-col>
                    </ion-row>
                </ion-grid>
                <ion-button v-if="receivedLikes.length" class="full-list-btn" @click="showMoreLikers" strong>{{
                    $t('master.fullList')
                }}</ion-button>
            </ion-col>
            <ion-col size="12" size-xl="6" class="ion-no-margin ion-no-padding">
                <ion-item class="ion-margin-top ion-padding-left header-box" lines="none">
                    <div slot="start">
                        <ion-text class="likes-title" color="secondary">{{ $t('privateProfile.likesMadeTitle') }}</ion-text>
                    </div>
                    <div class="numbers" slot="end">
                        <ion-text color="primary">{{ madeLikesCount }}</ion-text>
                    </div>
                </ion-item>
                <ion-item class="interactions-wrapper" lines="none">
                    <ion-text class="ion-float-start interactions">
                        {{
                            $t('privateProfile.likesMadeText', {
                                count: madeLikesCount
                            })
                        }}
                    </ion-text>
                </ion-item>
                <ion-grid class="user-cards">
                    <ion-row>
                        <ion-col v-for="like in madeLikes" :key="like.to_user.id" size-xs="6" size-sm="6" size-md="4">
                            <user-card :user="like.to_user" />
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </div>
</template>

<script>
import AxiosController from '@/controllers/AxiosController'
import PageHeader from '@/components/PageHeader'
import AdLeaderboard from '@/components/AdLeaderboard'
import UserCard from '@/components/UserCard'
import { mapGetters } from 'vuex'
import { isMobile } from 'mobile-device-detect'
import { constants } from '../../constants'

export default {
    name: 'PrivateProfile',
    components: { PageHeader, UserCard, AdLeaderboard },
    computed: mapGetters(['user']),
    data() {
        return {
            constants,
            madeLikes: [],
            receivedLikes: [],
            madeLikesCount: 0,
            receivedLikesCount: 0,
            receivedViewsCount: 0,
            receivedMessagesCount: 0,
            sentMessagesCount: 0,
            showingSettings: false,
            isMobile
        }
    },
    mounted() {
        AxiosController.get('/users/me').then(res => {
            const {
                received_likes,
                made_likes,
                made_likes_count,
                received_likes_count,
                received_views,
                received_messages,
                sent_messages
            } = res.data
            this.receivedLikes = received_likes
            this.madeLikes = made_likes
            this.madeLikesCount = made_likes_count
            this.receivedLikesCount = received_likes_count
            this.receivedViewsCount = received_views
            this.receivedMessagesCount = received_messages
            this.sentMessagesCount = sent_messages
        })
    },
    methods: {
        upgradeMembership() {
            this.$router.push('/plans')
        },
        toggleSettings() {
            this.showingSettings = !this.showingSettings
        },
        showMoreLikers() {
            this.$router.push('/likers-list')
        },
        redirectToChat() {
            this.$router.push('/messages')
        },
        redirectToVisitors() {
            this.$router.push('/profile-viewers')
        }
    }
}
</script>

<style lang="scss" scoped>
.clickable {
    cursor: pointer;
}

ion-button {
    --border-radius: 20px;
}
.profile-settings-header {
    background-color: #f5f5f5;
    --ion-background-color: #f5f5f5;
}

h4 {
    color: #114f64;
}

.stats-wrapper {
    background-color: #f5f5f5;

    .first-row {
        --ion-background-color: #f5f5f5;

        ion-text {
            font-size: 85%;
        }
    }
    .second-row {
        --ion-background-color: #f5f5f5;
        margin: auto;
        width: 55%;
        border-top: 1px solid #cacaca;

        ion-text {
            font-size: 85%;
        }
    }
}

.upgrade-membership {
    margin-top: 30px;

    .membership-text {
        font-size: 80%;
        text-align: start;
    }
    .membership-title {
        font-weight: 600;
    }
}

.user-cards {
    padding-top: 0;
}

.likes-title {
    font-weight: 600;
}

.full-list-btn {
    width: 50%;
}

.numbers {
    margin-top: 5px;
    font-weight: 700;
}
.interactions-wrapper {
    --min-height: auto;

    .interactions {
        font-size: 80%;
    }
}

.settings-button {
    width: 120px;
    height: 35px;
    font-size: 15px;

    .settings-icon {
        color: #000000;
    }
}

.settings-list {
    background: #114f64;
    border-radius: 10px;
    margin: 0;
    padding: 0;
    list-style: none;
    overflow: hidden;

    .settings-list-item {
        font-size: 13px;
    }
}
.banner {
    margin: 20px 10px;
}

.blocks-wrapper {
    .user-blocks {
        border-bottom: 1px solid #b1b1b1;
    }
    ion-item {
        --background: #f5f5f5;

        ion-text {
            font-weight: 700;
        }
    }
}

@media (min-width: 768px) {
    .full-list-btn {
        width: 33%;
        font-size: 20px;
        --border-radius: 30px;
    }

    .upgrade-button {
        font-size: 20px;
        --border-radius: 30px;
        width: 40%;
    }

    .likes-title,
    .membership-title {
        font-size: 20px;
    }

    .membership-text {
        font-size: 105% !important;
    }

    .interactions {
        font-size: 100% !important;
    }

    .numbers {
        ion-text {
            font-size: 25px;
        }
    }
    .blocks-wrapper {
        ion-row {
            // height: 7vh;

            ion-text {
                font-size: 20px;
                line-height: 7vh;

                &.number {
                    font-size: 25px;
                }
            }
        }
    }
}

@media (min-width: 1200px) {
    .sent-messages-box {
        border-left: 1px solid #e2e2e2;
        border-right: 1px solid #e2e2e2;
    }

    .second-row {
        border-top: none !important;
        width: 100% !important;
    }

    .interactions-wrapper {
        --background: transparent;
    }

    .header-box {
        --background: transparent;
    }

    .upgrade-button {
        font-size: 90%;
    }
}
</style>
